import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import EquipmentListV1 from 'components/modules/equipment/List';
import EquipmentListV2 from 'components/modules/equipment/v2/EquipmentList';
/**
 * Switches between v1 and v2 of the Equipment list page.
 *
 * URL overrides take precedence over the LaunchDarkly flag:
 *   - `?version=1` forces v1 (manual override for QA / dev preview)
 *   - `?version=2` forces v2 (manual override for QA / dev preview)
 *
 * Otherwise v2 is shown when the LaunchDarkly flag `enableEquipmentV2` is on,
 * falling back to v1.
 */
export function EquipmentRouter(props) {
    const flags = useFlags();
    const params = new URLSearchParams(window.location.search);
    const versionParam = params.get('version');
    const showV2 = versionParam === '2' ||
        (versionParam !== '1' && Boolean(flags.enableEquipmentV2));
    const Component = showV2 ? EquipmentListV2 : EquipmentListV1;
    return React.createElement(Component, Object.assign({}, props));
}
export default EquipmentRouter;
